import { getSecurityAlerts } from './utils/alerts-api'
import { Panel } from './Panel'

const SEVERITY_COLORS = {
  critical: 'text-red-500',
  high: 'text-amber-600',
  medium: 'text-yellow-500',
  low: 'text-gray-300',
  informational: 'text-gray-300',
} as const

export function SecurityAlerts() {
  return (
    <Panel
      title="Security alerts"
      getItems={getSecurityAlerts}
      getId={item => item.ghsaId}
      getGroup={item => item.severity}
      getGroupColor={group => SEVERITY_COLORS[group]}
      defaultGroup='critical'
      getRow={item => (
        <>
          <span className="w-[300px]">{item.packageName}</span>
          <span className="flex-grow">{item.summary}</span>
          <span>affects {item.repositories.length} repositories</span>
        </>
      )}
      getDetails={item => (
        <div className="flex w-full flex-col">
          {item.repositories.map((repository) => (
            <div key={repository.url} className="flex w-full pl-5 px-4 py-2 border-b bg-lime-50">
              <span className="pl-5 flex-grow">{repository.name}</span>
              <a target="_blank" rel="noreferrer" className="hover:bg-blue-100" href={repository.url}>
                {repository.url}
              </a>
            </div>
          ))}
        </div>
      )}
    />
  )
}
